export const ANONYMOUS = 'Anonymous';
export const UNIDENTIFIED = 'unidentified';
export const ANONYMOUS_USER_DISPLAY_NAME = 'Anonymous';
export const LONG_TABLE_PER_PAGE_LIMIT = 100;
export const SHORT_TABLE_PER_PAGE_LIMIT = 25;

export const SORT_DESC_STRING = 'desc';

export enum SortOrder {
	ASC = 'ASC',
	DESC = 'DESC',
}

export enum ContentViewsSortKey {
	TOTAL_VIEWED = 'totalViewed',
	TOTAL_COMMENTS = 'totalComments',
	UNIQUE_USERS_VIEWED = 'uniqueUsersViewed',
	LAST_VIEWED_AT = 'lastViewedAt',
	LAST_MODIFICATION_DATE = 'lastModificationDate',
}

export enum UsersActivitySortKey {
	CREATED = 'created',
	VIEWED = 'viewed',
	UPDATED = 'updated',
	COMMENT_CREATED = 'commentCreated',
}

export enum SpaceTableSortKeyV2 {
	TOTAL_CREATED = 'totalCreated',
	TOTAL_UPDATED = 'totalUpdated',
	TOTAL_VIEWED = 'totalViewed',
	UNIQUE_USERS = 'uniqueUsers',
	LAST_VIEWED_AT = 'lastViewedAt',
}

// This export is being duplicated in the __playwright__/page-objects/ConfluenceAnalytics.ts file as it
// cannot be imported; if changed, update there as well
export enum AnalyticsUIState {
	Error = 'Error',
	PartialDataError = 'PartialDataError',
	Loading = 'Loading',
	Data = 'Data',
	Empty = 'Empty',
}

export enum AnalyticsContainer {
	PAGE = 'Page',
	SPACE = 'Space',
	SITE = 'Site',
}
